import { EstateResultItem_OneViewNameInput } from 'queries';

import Asset from './asset';

type Props = {
  id: string;
  showAssetBtn: boolean;
  name: EstateResultItem_OneViewNameInput;
  assignButton?: React.ReactNode;
  title: string;
};

export default function NameAsset({ id, showAssetBtn, assignButton, title }: Props) {
  return <Asset key={id} showAssetBtn={showAssetBtn} assignButton={assignButton} title={title} />;
}
